var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9163 10.2208H6.41634M1.83301 10.2208V5.98577C1.83301 4.11577 3.34551 2.60327 5.21551 2.60327H10.3672C12.2372 2.60327 13.7497 3.76744 13.7497 5.63744",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.023 11.1833C15.5647 11.6233 15.3447 12.3016 15.528 12.9983C15.7572 13.8508 16.6005 14.3916 17.4805 14.3916H18.333V15.7208C18.333 17.7466 16.6922 19.3875 14.6663 19.3875H5.49967C3.47384 19.3875 1.83301 17.7466 1.83301 15.7208V9.30412C1.83301 7.27828 3.47384 5.63745 5.49967 5.63745H14.6663C16.683 5.63745 18.333 7.28745 18.333 9.30412V10.6333H17.343C16.8297 10.6333 16.3622 10.835 16.023 11.1833Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 11.5683V13.4566C20.1665 13.97 19.7449 14.3916 19.2224 14.3916H17.4532C16.4632 14.3916 15.5557 13.6675 15.4732 12.6775C15.4182 12.1 15.6382 11.5591 16.0232 11.1833C16.3624 10.835 16.8299 10.6333 17.3432 10.6333H19.2224C19.7449 10.6333 20.1665 11.055 20.1665 11.5683Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e9c0c1efc4ee414cc33532734c70a818.svg";
export { ForwardRef as ReactComponent };